import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

//style="fill: rgb(255, 255, 255);"

const _angleDown: FunctionComponent<{ className?: string }> = ({ className }) => (
    <svg version='1.2' overflow='visible' preserveAspectRatio='none' viewBox='0 0 24 24' width='20' height='20'>
        <g>
            <path d='M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' vectorEffect='non-scaling-stroke' />
        </g>
    </svg>
);

const AngleDown = styled(_angleDown)``;

export default AngleDown;
